export const home = {
  hero: {
    title1: 'Filtration Avancée',
    title2: 'et Solutions de Purification',
    title3: 'Pour l\'Excellence Industrielle',
    subtitle: 'Des technologies de séparation, de clarification et de purification conçues pour optimiser vos processus industriels et améliorer les performances dans plusieurs secteurs.',
    discoverSolutions: 'Découvrir Nos Solutions',
    requestStudy: 'Demander une Étude',
    contactUs: 'Contactez-nous',
    scrollToExplore: 'Faites défiler pour explorer',
    imageAlt: 'Système de Filtration Industrielle Avancée',
  },
  overview: {
    whoWeAre: 'Qui Nous Sommes',
    description: 'est spécialisée dans les technologies avancées de séparation et de purification, fournissant des solutions de filtration complètes pour diverses applications industrielles au Cameroun et en Afrique.',
    leadingSpecialist: 'Spécialiste Leader en Solutions de Filtration',
    weDeliver: 'Nous fournissons des solutions de purification, de clarification et de séparation de pointe qui améliorent la performance des processus industriels dans plusieurs secteurs.',
    yearsExperience: 'Années d\'Expérience',
    industriesServed: 'Industries Desservies',
    globalPartners: 'Partenaires Mondiaux',
    coreExpertise: 'Expertise Principale',
    scientificExpertise: 'Expertise Scientifique',
    scientificDescription: 'Recherche et développement avancés dans les technologies de séparation',
    processOptimization: 'Optimisation des Processus',
    processDescription: 'Amélioration continue des systèmes de filtration industriels',
    technicalSupport: 'Support Technique',
    supportDescription: 'Assistance et conseils d\'experts 24h/24 et 7j/7',
    qualityAssurance: 'Assurance Qualité',
    qualityDescription: 'Solutions certifiées ISO avec performance garantie',
    competitiveAdvantages: 'Avantages Concurrentiels',
    continuousInnovation: 'Innovation Continue & R&D',
    provenReliability: 'Fiabilité Industrielle Prouvée',
    costOptimization: 'Solutions d\'Optimisation des Coûts',
    customizedEngineering: 'Ingénierie Personnalisée',
    globalSupply: 'Réseau d\'Approvisionnement Mondial',
    comprehensiveSupport: 'Support Technique Complet',
    learnMore: 'En Savoir Plus Sur Nous',
    advancedTechnologies: 'Technologies de Filtration Avancées',
    technologyTypes: 'Osmose Inverse • Nanofiltration • Ultrafiltration • Microfiltration • Filtration Grossière',
    exploreTechnologies: 'Explorer les Technologies',
  },
  technologies: {
    title: 'Technologies de Filtration Avancées',
    subtitle: 'Une gamme complète de technologies de séparation et de purification adaptées aux besoins industriels diversifiés',
    scrollLeft: 'Défiler à gauche',
    scrollRight: 'Défiler à droite',
    viewAll: 'Voir Toutes les Technologies',
    reverseOsmosis: 'Osmose Inverse',
    roDescription: 'Filtration membranaire à haute pression pour la purification complète et la dessalement de l\'eau et des fluides industriels.',
    nanofiltration: 'Nanofiltration',
    nfDescription: 'Séparation sélective des molécules dissoutes et des ions multivalents pour des applications industrielles précises.',
    ultrafiltration: 'Ultrafiltration',
    ufDescription: 'Séparation membranaire des macromolécules, des colloïdes et des particules en suspension dans les solutions.',
    microfiltration: 'Microfiltration',
    mfDescription: 'Élimination des bactéries, des solides en suspension et des grosses particules pour la clarification et la stérilisation.',
    coarseFiltration: 'Filtration Grossière',
    cfDescription: 'Préfiltration et élimination des grosses particules pour protéger les équipements et processus en aval.',
    keyApplications: 'Applications Clés :',
    waterTreatment: 'Traitement de l\'Eau',
    desalination: 'Dessalement',
    ultraPureWater: 'Eau Ultra-Pure',
    waterSoftening: 'Adoucissement de l\'Eau',
    colorRemoval: 'Élimination des Couleurs',
    pharmaceutical: 'Pharmaceutique',
    foodBeverage: 'Agroalimentaire & Boissons',
    proteinRecovery: 'Récupération des Protéines',
    wastewater: 'Eaux Usées',
    beverageClarification: 'Clarification des Boissons',
    sterileFiltration: 'Filtration Stérile',
    cellSeparation: 'Séparation Cellulaire',
    pretreatment: 'Prétraitement',
    sedimentRemoval: 'Élimination des Sédiments',
    equipmentProtection: 'Protection des Équipements',
    learnMore: 'En Savoir Plus',
  },
  partners: {
    title: 'Nos Partenaires Mondiaux',
    subtitle: 'Nous collaborons avec des fabricants de renommée mondiale pour fournir des solutions de filtration de la plus haute qualité, assurant performance, fiabilité et approvisionnement continu pour vos besoins industriels.',
    qualitySelection: 'Processus de Sélection Qualité',
    qualityDescription: 'Chaque partenaire est soigneusement sélectionné sur la base de l\'excellence technologique, de la qualité des produits, de la disponibilité mondiale et des performances industrielles éprouvées. Nous veillons à ce que vous receviez les meilleures solutions pour vos besoins spécifiques.',
    exploreAll: 'Explorer Tous les Produits',
    sagisaDescription: 'Solutions de filtration industrielle et médias filtrants de qualité pour diverses applications',
    imerysDescription: 'Solutions de filtration avancées pour les applications agroalimentaires, des boissons et industrielles',
    filtroxDescription: 'Solutions de filtration en profondeur et médias filtrants de haute qualité pour les processus critiques',
    threeMCTDescription: 'Technologies de filtration et de séparation industrielles haute performance',
    msDescription: 'Production de milieux microbiologiques pour les applications de laboratoire et industrielles',
    filterMedia: 'Média Filtrant',
    industrialFiltration: 'Filtration Industrielle',
    customSolutions: 'Solutions Sur Mesure',
    foodBeverage: 'Agroalimentaire & Boissons',
    mineralFiltration: 'Filtration Minérale',
    performanceMaterials: 'Matériaux de Performance',
    depthFiltration: 'Filtration en Profondeur',
    beverageProcessing: 'Traitement des Boissons',
    membraneTechnology: 'Technologie à Membrane',
    industrialSolutions: 'Solutions Industrielles',
    innovation: 'Innovation',
    cultureMedia: 'Milieux de Culture',
    laboratorySolutions: 'Solutions de Laboratoire',
    qualityControl: 'Contrôle Qualité',
  },
  industries: {
    title: 'Industries que Nous Servons',
    subtitle: 'Fourniture de solutions de filtration et de purification spécialisées dans plusieurs secteurs avec une expertise prouvée et une excellence technique',
    viewAll: 'Voir Toutes les Industries',
    exploreSolutions: 'Explorer les Solutions',
    foodBeverage: 'Agroalimentaire & Boissons',
    foodBeverageDesc: 'Solutions de clarification, de stérilisation et de purification pour la transformation alimentaire et la production de boissons',
    foodServiceFiltration: 'Filtration pour la Restauration',
    foodServiceDesc: 'Solutions de filtration de l\'eau, de qualité des boissons et de protection des équipements pour les restaurants, cafés et opérations de restauration',
    pharmaceutical: 'Pharmaceutique & Chimie',
    pharmaDesc: 'Filtration et séparation ultra-pure pour la fabrication pharmaceutique et le traitement chimique',
    waterTreatment: 'Traitement de l\'Eau',
    waterDesc: 'Technologies complètes de purification de l\'eau, de dessalement et de traitement des eaux usées',
    mining: 'Mines & Métallurgie',
    miningDesc: 'Séparation solide-liquide et traitement des eaux de processus pour l\'exploitation minière et l\'extraction de métaux',
    oilGas: 'Pétrole & Gaz',
    oilGasDesc: 'Filtration haute performance pour les opérations en amont, en aval et en aval',
  },
  cta: {
    ready: 'Prêt à Optimiser Vos Processus Industriels ?',
    description: 'Notre équipe d\'experts en filtration est prête à analyser vos besoins spécifiques et à recommander les solutions de purification et de séparation les plus efficaces pour vos opérations.',
    requestStudy: 'Demander une Étude Technique',
    response48h: 'Garantie de réponse sous 48 heures',
    confidential: 'Consultation confidentielle',
  },
};